import PropTypes from 'prop-types';
import {Navigate} from 'react-router-dom';
import {checkPermission} from './helper/RouteHelper';

const RoleGuard = ({children, permittedrole, userRole}) => {
  //  const componentName =
  //    children?.type?.name || children?.type?.displayName || 'UnknownComponent';
  //  console.log(
  //    `[RoleGuard] component: ${componentName}, permittedrole: ${permittedrole}, userRole: ${userRole}`,
  //  );

  const hasPermission = checkPermission(permittedrole, userRole);
  if (!hasPermission) {
    return <Navigate to='/e401' replace />;
  }
  return children;
};

RoleGuard.propTypes = {
  children: PropTypes.node.isRequired,
  permittedrole: PropTypes.string.isRequired,
  userRole: PropTypes.string, // Marked as not required if user can be unauthenticated
};

export default RoleGuard;
